export default __webpack_public_path__ + "static/media/loading-icon.42aaa181.jpg";